<app-header [isAlerts]="true"></app-header>
<ng-container *ngIf="preferencesPageViewModel$ | async as viewModel">
  <h2 class="title">Preference Center</h2>
  <div class="panel-header">Active Alerts</div>
  <div class="alert-panels-container">
    <app-alert-panel
      class="alert-panel"
      *ngFor="let panelViewModel of viewModel.alertPanelViewModels"
      [viewModel]="panelViewModel"
      (panelClick)="onAlertPanelClick($event)"
    ></app-alert-panel>
  </div>
  <div *ngIf="viewModel.alertPanelViewModels.length === 0" class="no-alerts">
    <ion-icon name="notifications-off-outline"></ion-icon>
    <p>No alert categories are available</p>
  </div>

  <ng-template #loading>
    <div class="loading-alerts">
      <ion-spinner name="circular"></ion-spinner>
      <p>Loading your alert preferences...</p>
    </div>
  </ng-template>
</ng-container>
<app-footer class="footer"></app-footer>
